/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) 2021 Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { Store } from '../../core/store/Store';
import { EntriesReviewModel } from '../../models/components/EntriesReviewModel';
import { Entry } from '../../types/course/Entry';

export class EntriesReviewStore extends Store {
	private entriesReviewModel: EntriesReviewModel = new EntriesReviewModel();

	public setEntries(entries: Entry[]): void {
		this.entriesReviewModel.setEntries(entries);
	}

	public getEntries(): Entry[] {
		return this.entriesReviewModel.entries;
	}

	public setNewEntries(entries: Entry[]): void {
		this.entriesReviewModel.setNewEntries(entries);
	}

	public getNewEntries(): Entry[] {
		return this.entriesReviewModel.newEntries;
	}

	public setApprovedEntries(entries: Entry[]): void {
		this.entriesReviewModel.setApprovedEntries(entries);
	}

	public getApprovedEntries(): Entry[] {
		return this.entriesReviewModel.approvedEntries;
	}

	public setRejectedEntries(entries: Entry[]): void {
		this.entriesReviewModel.setRejectedEntries(entries);
	}

	public getRejectedEntries(): Entry[] {
		return this.entriesReviewModel.rejectedEntries;
	}

	public getPageNumberNewEntries(): number {
		return this.entriesReviewModel.pageNumberNewEntries;
	}

	public setPageNumberNewEntries(pageNumber: number): void {
		this.entriesReviewModel.setPageNumberNewEntries(pageNumber);
	}

	public getPageNumberApproved(): number {
		return this.entriesReviewModel.pageNumberApproved;
	}

	public setPageNumberApproved(pageNumber: number): void {
		this.entriesReviewModel.setPageNumberApproved(pageNumber);
	}

	public getPageNumberRejected(): number {
		return this.entriesReviewModel.pageNumberRejected;
	}

	public setPageNumberRejected(pageNumber: number): void {
		this.entriesReviewModel.setPageNumberRejected(pageNumber);
	}

	public getNumberOfPagesNewEntries(): number {
		return this.entriesReviewModel.numberOfPagesNewEntries;
	}

	public setNumberOfPagesNewEntries(pageNumber: number): void {
		this.entriesReviewModel.setNumberOfPagesNewEntries(pageNumber);
	}

	public getNumberOfPagesApproved(): number {
		return this.entriesReviewModel.numberOfPagesApproved;
	}

	public setNumberOfPagesApproved(pageNumber: number): void {
		this.entriesReviewModel.setNumberOfPagesApproved(pageNumber);
	}

	public getNumberOfPagesRejected(): number {
		return this.entriesReviewModel.numberOfPagesRejected;
	}

	public setNumberOfPagesRejected(pageNumber: number): void {
		this.entriesReviewModel.setNumberOfPagesRejected(pageNumber);
	}

	public setEntry(entry?: Entry): void {
		this.entriesReviewModel.setEntry(entry);
	}

	public getEntry(): Entry | undefined {
		return this.entriesReviewModel.entry;
	}

	public setFeedback(feedback: string): void {
		this.entriesReviewModel.setFeedback(feedback);
	}

	public getFeedback(): string {
		return this.entriesReviewModel.feedback;
	}

	public isPublishingView(): boolean {
		return this.entriesReviewModel.isPublishingView;
	}

	public setIsPublishingView(bool: boolean): void {
		this.entriesReviewModel.setIsPublishingView(bool);
	}

	public isValidData(): boolean {
		return this.entriesReviewModel.isValidData;
	}

	public setIsValidData(bool: boolean): void {
		this.entriesReviewModel.setIsValidData(bool);
	}

	public closeDetailView(): void {
		this.setEntry(undefined);
		this.setIsPublishingView(false);
		this.setIsValidData(false);
	}
}
